import type { InputHTMLAttributes, Ref } from "react";
import { controlClass } from "./control.ts";

export type CellFieldProps = Omit<InputHTMLAttributes<HTMLInputElement>, "size"> & {
  /** The accessible name. Not shown: the column header, or the words beside it, name it on screen. */
  label: string;
  /** Draws the red border and sets `aria-invalid`. The message goes where the row shows its errors. */
  invalid?: boolean;
  ref?: Ref<HTMLInputElement>;
};

/**
 * A text input with no visible label, at the compact size: a cell in a table of rows (a price, a
 * start time, the places in a session), where the column header is the label. The same box as
 * `Field` (`control.ts`), so a cell and a form field are one control at two sizes. In a form, use
 * `Field`, which shows its label.
 */
export function CellField({ label, invalid = false, className = "", ...rest }: CellFieldProps) {
  return (
    <input
      aria-label={label}
      aria-invalid={invalid ? true : undefined}
      className={controlClass({
        size: "compact",
        error: invalid,
        className: ["px-2.5", className].filter(Boolean).join(" "),
      })}
      {...rest}
    />
  );
}
